
import { ApiConfig, ApiConfigType } from "./api-config"
import * as Result from "./api-result"
import * as Parameters from './api-parameters-type'
import * as Res from './api-res-type'
import { AxiosInstance, AxiosResponse } from 'axios'
import { createHttp } from './http';

export class Api {

  config: ApiConfigType
  http: AxiosInstance

  constructor (config: ApiConfigType = ApiConfig) {
    this.config = config
    this.http = createHttp(this.config)
  }

  // 资源管理

  async PostAssetUpload(params: Parameters.PostAssetUploadParameters): Promise<Result.PostAssetUploadResult> {
    try {

      const { files, ...body } = params

      const formData = new FormData();
      formData.append('width', String(body.width));
      formData.append('height', String(body.height));
      formData.append('thumbnailWidth', String(body.thumbnailWidth));
      formData.append('thumbnailHeight', String(body.thumbnailHeight));
      formData.append('files', files)

      const res = await this.http.post(`/asset/v1/upload`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })

      const data: Res.PostAssetUploadRes = res.data
        ?.data
      return { kind: 'ok', data: data }
    } catch (res: any) {
      const { data = {} } = res?.response || {}
      const { code = '' } = data

      return { kind: code, status: res.status, message: data.message }
    }
  }

  async GetAsset(id: string): Promise<Result.GetAssetResult> {
    try {
      const res = await this.http.get(`/asset/v1/${id}`)
      const data: Res.GetAssetRes = res.data?.data
      return { kind: 'ok', data: data }
    } catch (res: any) {
      const { data = {} } = res?.response || {}
      const { code = '' } = data

      return { kind: code, status: res.status, message: data.message }
    }
  }

  // 用户注册

  async PostAuthRegister(params: Parameters.PostAuthRegisterParameters): Promise<Result.PostAuthRegisterResult> {
    try {
      const res = await this.http.post(`/auth/v1/register`, params)
      const data: Res.PostAuthRegisterRes = res.data?.data
      localStorage.setItem('jwt_token', data.token ?? '');

      return { kind: 'ok', data: data }
    } catch (res: any) {
      const { data = {} } = res?.response || {}
      const { code = '' } = data

      return { kind: code, status: res.status, message: data.message }
    }
  }

  // 用户登录
  async PostAuthLogin(params: Parameters.PostAuthLoginParameters): Promise<Result.PostAuthLoginResult> {
    try {
      const res = await this.http.post(`/auth/v1/login`, params)
      const data: Res.PostAuthLoginRes = res.data?.data

      localStorage.setItem('jwt_token', data.token ?? '');

      return { kind: 'ok', data: data }
    } catch (res: any) {
      const { data = {} } = res?.response || {}
      const { code = '' } = data

      return { kind: code, status: res.status, message: data.message }
    }
  }

  // 发送验证码
  async PostAuthSendVerificationCode(params: Parameters.PostAuthSendVerificationCodeParameters): Promise<Result.PostAuthSendVerificationCodeResult> {
    try {
      const res = await this.http.post(`/auth/v1/send-verification-code`, params)
      const data: Res.PostAuthSendVerificationCodeRes = res.data?.data
      return { kind: 'ok', data: data }
    } catch (res: any) {
      const { data = {} } = res?.response || {}
      const { code = '' } = data

      return { kind: code, status: res.status, message: data.message }
    }
  }

  // 检查邮箱或手机号是否存在
  async PostAuthCheckAccountExists(params: Parameters.PostAuthCheckAccountExistsParameters): Promise<Result.PostAuthCheckAccountExistsResult> {
    try {
      const res = await this.http.post(`/auth/v1/check-account-exists`, params)
      const data: Res.PostAuthCheckAccountExistsRes = res.data?.data
      return { kind: 'ok', data }
    } catch (res: any) {
      const { data = {} } = res?.response || {}
      const { code = '' } = data

      return { kind: code, status: res.status, message: data.message }
    }
  }


  // 用户登出
  async PostAuthLogout(): Promise<Result.PostAuthLogoutResult> {
    try {
      const res = await this.http.post(`/auth/v1/logout`)
      const data: Res.PostAuthLogoutRes = res.data?.data
      return { kind: 'ok', data: data }
    } catch (res: any) {
      const { data = {} } = res?.response || {}
      const { code = '' } = data

      return { kind: code, status: res.status, message: data.message }
    }
  }


  // 确认邮箱
  async PostAuthConfirmEmail(params: Parameters.PostAuthConfirmEmailParameters): Promise<Result.PostAuthConfirmEmailResult> {
    try {
      const res = await this.http.post(`/auth/v1/confirm-email`, params)
      const data: Res.PostAuthConfirmEmailRes = res.data?.data
      return { kind: 'ok', data: data }
    } catch (res: any) {
      const { data = {} } = res?.response || {}
      const { code = '' } = data

      return { kind: code, status: res.status, message: data.message }
    }
  }

  // 创建筹款活动
  async PostCampaign(params: Parameters.PostCampaignParameters): Promise<Result.PostCampaignResult> {
    try {
      const res = await this.http.post(`/campaign/v1`, params)
      const data: Res.PostCampaignRes = res.data?.data
      return { kind: 'ok', data: data }
    } catch (res: any) {
      const { data = {} } = res?.response || {}
      const { code = '' } = data

      return { kind: code, status: res.status, message: data.message }
    }
  }

  // 获取筹款活动列表
  async GetCampaignList(params: Parameters.GetCampaignListParameters): Promise<Result.GetCampaignListResult> {
    try {
      const res = await this.http.get(`/campaign/v1`, { params })
      const data: Res.GetCampaignListRes = res.data?.data
      return { kind: 'ok', data: data }
    } catch (res: any) {
      const { data = {} } = res?.response || {}
      const { code = '' } = data

      return { kind: code, status: res.status, message: data.message }
    }
  }

  // 获取筹款活动详情
  async GetCampaign(params: Parameters.GetCampaignParameters): Promise<Result.GetCampaignResult> {
    try {
      const res = await this.http.get(`/campaign/v1/${params.id}`, { params })
      const data: Res.GetCampaignRes = res.data?.data
      return { kind: 'ok', data: data }
    } catch (res: any) {
      const { data = {} } = res?.response || {}
      const { code = '' } = data

      return { kind: code, status: res.status, message: data.message }
    }
  }


  // 更新筹款活动
  async PutCampaign(params: Parameters.PutCampaignParameters): Promise<Result.PutCampaignResult> {
    try {
      const { id, ...body } = params

      const res = await this.http.put(`/campaign/v1/${params.id}`, body)
      const data: Res.PutCampaignRes = res.data?.data
      return { kind: 'ok', data: data }
    } catch (res: any) {
      const { data = {} } = res?.response || {}
      const { code = '' } = data

      return { kind: code, status: res.status, message: data.message }
    }
  }


  // 删除筹款活动
  async DeleteCampaign(params: Parameters.DeleteCampaignParameters): Promise<Result.DeleteCampaignResult> {
    try {
      const res = await this.http.delete(`/campaign/v1/${params.id}`, { params })
      const data: Res.DeleteCampaignRes = res.data?.data
      return { kind: 'ok', data: data }
    } catch (res: any) {
      const { data = {} } = res?.response || {}
      const { code = '' } = data

      return { kind: code, status: res.status, message: data.message }
    }
  }


  // 获取活动主题详情
  async GetCampaignThemeList(params: Parameters.GetCampaignThemeListParameters): Promise<Result.GetCampaignThemeListResult> {
    try {
      const res = await this.http.get(`campaign-theme/v1`, { params })
      const data: Res.GetCampaignThemeListRes = res.data?.data
      return { kind: 'ok', data: data }
    } catch (res: any) {
      const { data = {} } = res?.response || {}
      const { code = '' } = data

      return { kind: code, status: res.status, message: data.message }
    }
  }


  // 获取活动主题详情
  async GetCampaignTheme(params: Parameters.GetCampaignThemeParameters): Promise<Result.GetCampaignThemeResult> {
    try {
      const res = await this.http.get(`campaign-theme/v1/${params.id}`, { params })
      const data: Res.GetCampaignThemeRes = res.data?.data
      return { kind: 'ok', data: data }
    } catch (res: any) {
      const { data = {} } = res?.response || {}
      const { code = '' } = data

      return { kind: code, status: res.status, message: data.message }
    }
  }


  // 创建捐款记录
  async PostDonation(params: Parameters.PostDonationParameters): Promise<Result.PostDonationResult> {
    try {
      const res = await this.http.post(`/donation/v1`, params)
      const data: Res.PostDonationRes = res.data?.data
      return { kind: 'ok', data: data }
    } catch (res: any) {
      const { data = {} } = res?.response || {}
      const { code = '' } = data

      return { kind: code, status: res.status, message: data.message }
    }
  }


  // 获取捐款记录列表
  async GetDonationList(params: Parameters.GetDonationListParameters): Promise<Result.GetDonationListResult> {
    try {
      const res = await this.http.get(`/donation/v1`, { params })
      const data: Res.GetDonationListRes = res.data?.data
      return { kind: 'ok', data: data }
    } catch (res: any) {
      const { data = {} } = res?.response || {}
      const { code = '' } = data

      return { kind: code, status: res.status, message: data.message }
    }
  }

  // 获取捐款记录详情
  async GetDonation(params: Parameters.GetDonationParameters): Promise<Result.GetDonationResult> {
    try {
      const res = await this.http.get(`/donation/v1/${params.id}`, { params })
      const data: Res.GetDonationRes = res.data?.data
      return { kind: 'ok', data: data }
    } catch (res: any) {
      const { data = {} } = res?.response || {}
      const { code = '' } = data

      return { kind: code, status: res.status, message: data.message }
    }
  }

  // 更新捐款记录
  async PutDonation(params: Parameters.PutDonationParameters): Promise<Result.PutDonationResult> {
    try {
      const { id, ...body } = params
      
      const res = await this.http.put(`/donation/v1/${id}`, body)
      const data: Res.PutDonationRes = res.data?.data
      return { kind: 'ok', data: data }
    } catch (res: any) {
      const { data = {} } = res?.response || {}
      const { code = '' } = data

      return { kind: code, status: res.status, message: data.message }
    }
  }



  // 获取筹款活动详情
  async GetUser(params: Parameters.GetUserParameters): Promise<Result.GetUserResult> {
    try {
      const res = await this.http.get(`/user/v1/${params.id}`, { params })
      const data: Res.GetUserRes = res.data?.data
      return { kind: 'ok', data: data }
    } catch (res: any) {
      const { data = {} } = res?.response || {}
      const { code = '' } = data

      return { kind: code, status: res.status, message: data.message }
    }
  }


  // 更新捐款记录
  async PutUser(params: Parameters.PutUserParameters): Promise<Result.PutUserResult> {
    try {
      const { id, ...body } = params
      const res = await this.http.put(`/user/v1/${params.id}`, body)
      const data: Res.PutUserRes = res.data?.data
      return { kind: 'ok', data: data }
    } catch (res: any) {
      const { data = {} } = res?.response || {}
      const { code = '' } = data

      return { kind: code, status: res.status, message: data.message }
    }
  }


  // 创建 PayMe 支付请求
  async PostPaymePayment(params: Parameters.PostPaymePaymentParameters): Promise<Result.PostPaymePaymentResult> {
    try {
      const res = await this.http.post(`/payme/v1/payment`, params)
      const data: Res.PostPaymePaymentRes = res.data?.data
      return { kind: 'ok', data: data }
    } catch (res: any) {
      const { data = {} } = res?.response || {}
      const { code = '' } = data

      return { kind: code, status: res.status, message: data.message }
    }
  }

  // 提交联系表单
  async PostContact(params: Parameters.PostContactParameters): Promise<Result.PostContactResult> {
    try {
      const res = await this.http.post(`/contact/v1`, params)
      const data: Res.PostContactRes = res.data?.data
      return { kind: 'ok', data: data }
    } catch (res: any) {
      const { data = {} } = res?.response || {}
      const { code = '' } = data

      return { kind: code, status: res.status, message: data.message }
    }
  }









}

